import React from "react"
import schoolgate from "../Assets/schoolgate.jpg";

const PageBanner = ({ eyebrow, title }) => {
    return (
        <div
            className="relative w-full h-72 md:h-80 bg-cover bg-center"
            style={{ backgroundImage: `url(${schoolgate})` }}
        >
            <div className="absolute inset-0 bg-[#12213D]/80 flex flex-col justify-center px-4 md:px-10 lg:px-16">
                {eyebrow && (
                    <div className="flex items-center gap-2 mb-4">
                        <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                        <span className="text-[#B8862E] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                            {eyebrow}
                        </span>
                    </div>
                )}
                <h1
                    className="text-[#F6F5F1] text-4xl md:text-5xl"
                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                >
                    {title}
                </h1>
            </div>
        </div>
    )
}

export default PageBanner;